<template>
  <div>
    <Invitee v-for="(invitee, key) in invitees" v-bind="invitee" :key="key">
      <template v-if="editable">
        <span class="icon-remove" @click="$emit('removed', key)">
          <i class="fas fa-minus-circle"></i>
        </span>
      </template>
    </Invitee>
  </div>
</template>

<script>
import Invitee from './Item';

export default {
  components: { Invitee },
  props: {
    invitees: Array,
    editable: Boolean,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Booking/Invites/List.vue